export default "__VITE_ASSET__BLInu92C__"